import * as XLSX from 'xlsx';

const autoSizing = <T>(sheet: XLSX.WorkSheet, data: T[]) => {
  const items = data.map((item) => Object.values(item));
  const criteria = items[0];

  const calculated = items
    .map((item) => item.map((each) => `${each}`).map((each) => each.length + 1))
    .reduce((prev: number[], curr: number[]) => prev.map((item, i) => Math.max(item, curr[i])));

  sheet['!cols'] = criteria?.map((_, i) => ({ wch: calculated[i] }));
};

export const writeFile = <T>(data: T[], titles?: string[], fileName?: string) => {
  if (data.isEmpty()) {
    return;
  }

  const sheet = XLSX.utils.json_to_sheet(data);
  const book = XLSX.utils.book_new();

  if (titles) {
    titles.forEach((title, index) => {
      const cellAdd = XLSX.utils.encode_cell({ c: index, r: 0 });
      sheet[cellAdd].v = title;
    });
  }

  XLSX.utils.book_append_sheet(book, sheet, 'sheet1');

  autoSizing(sheet, data);

  XLSX.writeFile(book, fileName ?? 'result.xlsx');
};

export const read = <T>(data: T[]) => {
  XLSX.read(data);
};
